<template>
  <div class='core'>
    <div class='layui-fluid'>
      <pub-search
        :search-type="'add'"
        :tableObj='tableObj'
        :searchConfig='searchConfig'
        exportType="1"
      >
        <template>
          <el-button class="add-qr-code-style" type="primary" @click="dialogVisible = true" icon="el-icon-plus" size="small">新增二维码</el-button>
          <el-button class="add-qr-code-style" type="primary" @click="downloadQrCode()" icon="el-icon-download" size="small">下载</el-button>
          <el-dialog
            append-to-body
            title="新增二维码"
            :visible.sync="dialogVisible"
            width="25%"
            >
            <span>
               <span>新增二维码数量：</span><el-input-number v-model="num" @change="handleChange" :min="1" :max="30" size="small" label="描述文字"></el-input-number>
            </span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false" size="small">取 消</el-button>
              <el-button type="primary" @click="saveOnClick" size="small">确 定</el-button>
            </span>
          </el-dialog>
        </template>
      </pub-search>
      <layui-table
        ref='qrCodeManagerMainViewRef'
        table-name='YW_QR_CODE'
        :page-size='20'
        :page-range='6'
        :page-options='[10, 20, 50, 100]'
        :skin="'line'"
        :sort="['QR_CODE_ID:DESC']"
        @table-event-bind='bindQRCodeOnClick($event)'
        @table-event-remove-bind='removeBindQRCodeOnClick($event)'
      >
        <div>
          <div checkbox='true' align='center' fixed='left' width='60'></div>
          <layui-tableconfig :config='mdTableList'></layui-tableconfig>
          <div rowspan='3' align='center' fixed='right' title='操作' width='130'>
            <script type='text/html' v-pre>
              {{#  if(d.B_BIND == 0){ }}
              <a class='layui-btn-xs' lay-event='bind'>绑定</a>
              {{#  } }}
              {{#  if(d.B_BIND == 1){ }}
              <a class='layui-btn-xs' lay-event='remove-bind' style='color:red'>解绑</a>
              {{#  } }}
            </script>
          </div>
        </div>
      </layui-table>
    </div>
  </div>
</template>
<script>
import "../../../utils/map/css/core.css"
import request from "@/network/networkconfig";


export default {
  name: 'qrCodeManage',
  data () {
    return {
      mdTableList: [
        {field: 'QR_CODE_NUM', title: '二维码编号', width: 150},
        {field: 'QR_CODE_CONTENT', title: '二维码内容', width: 440},
        {field: 'STORE_NAME', title: '门店名称', width: 250},
        {field: 'CREATE_TIME', title: '创建时间', width: 250},
        {field: 'B_BIND_DESC', title: '是否绑定', width: 150, translateDomain: 'TRNSLATE_SF'},
        {field: 'MEMO', title: '备注'},
      ],
      tableObj: {
        checkedRows: 0,
        queryObject: {}
      },
      searchConfig: {
        basic: [
          {
            TYPE: 'input',
            WIDTH: 260,
            FIELD: 'QR_CODE_NUM:2, QR_CODE_CONTENT:2, STORE_NAME:2',
            PLACEHOLDER: '请输入查询条件'
          }
        ],
        advanced: [
          {TYPE: 'input', NAME: '二维码编号 :', FIELD: 'QR_CODE_NUM:2', PLACEHOLDER: '请输入二维码编号'},
          {TYPE: 'input', NAME: '二维码内容 :', FIELD: 'QR_CODE_CONTENT:2', PLACEHOLDER: '请输入二维码内容'},
          {TYPE: 'input', NAME: '门店名称 :', FIELD: 'STORE_NAME:2', PLACEHOLDER: '请输入门店名称'},
          {
            TYPE: 'layui-multiselect',
            NAME: '是否绑定:',
            FIELD: 'B_BIND:1',
            textField: 'text',
            valueField: 'value',
            initData: this.dict.getData('FILTER_SF'),
          },
          {TYPE: 'date', NAME: '创建时间 :', FIELD: 'CREATE_TIME:2', PLACEHOLDER: '请选择创建时间'},
        ],
        showBatch: false
      },
      dialogVisible: false,
      num: 1
    }
  },
  mounted(){
    this.tableObj = this.$refs.qrCodeManagerMainViewRef;
  },
  methods: {
    bindQRCodeOnClick($event) {
      this.baseComponent.smartLoadComponent('qrCodeManageForm', {editRow: $event.data, tableObj: this.tableObj, formType: 'edit', title: '绑定门店'});
    },

    removeBindQRCodeOnClick(data) {
      request({
        url: '/yw/qrCodeManage/removeBindQrCode/' + data.data.QR_CODE_ID,
        method: 'post',
      }).then(result => {
        if (result.result.errorMsg) {
          this.layer.openAlert(result.result.errorMsg)
        } else {
          this.layer.openSuccess('解绑成功!', { targetEl: $('body')})
          this.tableObj.load();
        }
      }, null, { targetEl : $('body')})
    },

    saveOnClick() {
      this.dialogVisible = false

      request({
        url: '/yw/qrCodeManage/addQrCode/' + this.num,
        method: 'post',
      }).then(result => {
        if (result.result.errorMsg) {
          this.layer.openAlert(result.result.errorMsg)
        } else {
          this.layer.openSuccess('新增成功!', { targetEl: $('body')})
          this.tableObj.load();
          this.num = 1
        }
      }, null, { targetEl : $('body')})
    },

    handleChange(value) {
      this.num = value
    },

    downloadQrCode() {
      let selectedRows = this.tableObj.checkedRows;
      if (!selectedRows || selectedRows.length < 1) {
        this.layer.openAlert('请至少选择一条记录!');
        return;
      }

      let qr_code_num_list = []
      for (let item of selectedRows) {
        qr_code_num_list.push(item.QR_CODE_NUM)
      }

      let token = this.security.getToken()
      this.exportUrl = process.env.API_HOST + '/yw/qrCodeManage/downloadQRCode/' + qr_code_num_list.join();

      let formHtml = '<form  method="post" action="' + (this.exportUrl) + '" style="display:none;" accept-charset="UTF-8">'
      formHtml += '<input type="hidden" name="token"' + '" value="' + token + '">'
      formHtml += '</form>'

      $(formHtml).appendTo($('body')).submit()
    }
  }
}
</script>

<style scoped>
.add-qr-code-style{
  background: #00A0E9;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/repairs/qrCodeManage/index.vue